import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdBrazeDocsSearchCacheKeys: AllRouteEndpoints[] = [];
